module.exports = "/src/views/games/other/images/action/killed.png";